import React from 'react';
import { Box, Inline } from '@styleseat/ui';
import { colors } from '@styleseat/brand';
import { BodyText } from '../../../../ui';
import { NotificationsAlertCircleIcon } from '../../../../ui/Icons';
import type { ProAppointment } from '../../../../../api/Providers/Appointments';

type MessageProps = {
  inCancellationWindow: boolean;
  proCanCancel: boolean;
  appointment: ProAppointment;
};

const Message: React.FC<MessageProps> = ({
  inCancellationWindow,
  proCanCancel,
  appointment,
}) => {
  let message: string;
  if (inCancellationWindow && proCanCancel) {
    message = 'Your search ranking will decrease if you cancel this appointment.';
  }
  if (inCancellationWindow && !proCanCancel) {
    message = `Only ${appointment.client.name.split(' ')[0]} can cancel this appointment at this time.`;
  }
  if (!inCancellationWindow) {
    message = "This appointment can't be canceled because it's past the start time.";
  }
  return (
    <Box
      paddingX={24}
    >
      <Box
        padding={16}
        color={inCancellationWindow ? colors.warningBackground : colors.redLite}
      >
        <Inline
          space={12}
        >
          <Box
            paddingTop={2}
            testID="cancel-appointment-modal-warning-message-icon"
          >
            <NotificationsAlertCircleIcon
              width={24}
              height={24}
              color={inCancellationWindow ? colors.warningBackground : colors.whiteWash}
              backgroundColor={inCancellationWindow ? colors.sunshine : colors.red}
              borderColor={inCancellationWindow ? colors.sunshine : colors.red}
            />
          </Box>
          <BodyText
            weight="bold"
            testID="cancel-appointment-modal-warning-message-text"
          >
            {message}
          </BodyText>
        </Inline>
      </Box>
    </Box>
  );
};

export default Message;
